
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 .1C4.5.1.1 4.5.1 10s4.4 9.9 9.9 9.9 9.9-4.4 9.9-9.9S15.5.1 10 .1zm-.2 14.5c-.5 0-1-.4-1-.9s.4-.9 1-.9 1 .4 1 .9-.4.9-1 .9zm1.9-4.5l-.7.5c-.3.2-.4.5-.4.8v.5H9.1v-.6c0-.8.3-1.3.9-1.7l.7-.6c.4-.3.6-.6.6-1.1 0-.6-.4-1.1-1.2-1.1C9.4 6.8 9 7.4 9 8H7.4c0-1.4.9-2.7 2.7-2.7 1.8 0 2.8 1.1 2.8 2.5.1 1.2-.6 1.8-1.2 2.3z"}})])
          )
        }
      }
    